import script from "./OccupancyExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupancyExpenses.vue?vue&type=script&setup=true&lang=js"

import "./OccupancyExpenses.vue?vue&type=style&index=0&id=3b5ac64d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5ac64d"]])

export default __exports__